import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { disabledProgress } from '../config/progress.inteceptor';
import { DashboardType } from './dashboard.type';

@Injectable()
export class DashboardService {
  constructor(private http: HttpClient) {}

  getInboundQueue(msisdns?): any {
    return this.http.get<any>(`/inbound/queue`, {
      params: { msisdns: msisdns ? msisdns.toString() : '' },
      ...disabledProgress
    });
  }

  getInboundStats(msisdns?): any {
    return this.http.get<any>(`/inbound/statistics`, {
      params: { msisdns: msisdns ? msisdns.toString() : '', timezoneOffsetMinutes: `${moment().utcOffset()}` },
      ...disabledProgress
    });
  }

  getWorkingUsersInbound(msisdns?): any {
    return this.http.get<any>(`/users/working-inbound`, {
      params: { msisdns: msisdns ? msisdns.toString() : '', timezoneOffsetMinutes: `${moment().utcOffset()}` },
      ...disabledProgress
    });
  }

  getCallVolume(dashboardType: DashboardType): any {
    return this.http.get<any>(`/dashboard`, {
      params: { dashboardType, timezoneOffsetMinutes: `${moment().utcOffset()}`, rangeDays: '30' },
      ...disabledProgress
    });
  }
}
